import { Component, Inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LocalStorageService } from 'src/app/services/local-storage.service';
import { PlausibleAnalyticsService } from 'src/app/services/plausible-analytics.service';
import { SolarService } from 'src/app/services/cadastre-solaire/cadastre-solaire.service';
import { SolarPvTotalityService } from 'src/app/services/cadastre-solaire/cadastre-solaire-pv-totality.service';
import { SolarPvSurplusService } from 'src/app/services/cadastre-solaire/cadastre-solaire-pv-surplus.service';

import { environment } from 'src/environments/environment';
import { Contact, Profile, ProfileEnum } from 'src/app/models/Solar';

@Component({
    selector: 'cadastreSolaireContactModal',
    templateUrl: './cadastre-solaire-contact-modal.template.html',
    styleUrls: ['./cadastre-solaire-contact-modal.component.scss'],
    standalone: false,
})
export class CadastreSolaireContactModalComponent implements OnInit {
    public htmlContact: any;
    public contactButtonLabel: string = 'Contacter un expert';
    public introduction: string = 'Vous voulez en savoir plus sur votre installation solaire ?';

    public name = environment.name;

    public profile: ProfileEnum | null;

    public isCofor: boolean = false;
    public isFranceRenov: boolean = false;
    public isCitemetrie: boolean = false;

    constructor(
        @Inject(LocalStorageService) private localStorageService: LocalStorageService,
        @Inject(PlausibleAnalyticsService)
        private plausibleAnalyticsService: PlausibleAnalyticsService,
        @Inject(SolarService) private solarService: SolarService,
        @Inject(SolarPvTotalityService) private solarPvTotalityService: SolarPvTotalityService,
        @Inject(SolarPvSurplusService) private solarPvSurplusService: SolarPvSurplusService,
        public activeModal: NgbActiveModal,
    ) {
        this.profile = this.solarService.getProfile();
    }

    ngOnInit(): void {
        const user = this.localStorageService.get('user');
        this.plausibleAnalyticsService.trackEvent('Projet Solaire - Contact', {
            utilisateur_id: user.id,
        });

        if (this.name == 'cadastre_cap_azur') {
            this.introduction =
                'Vous souhaitez concrétiser votre projet solaire ? Voici quelques liens utiles :';
        }

        this.onOpen();
    }

    onOpen() {
        const moduleInfo = this.solarService.moduleInfo;

        if (moduleInfo) {
            const customContactButtonLabel = moduleInfo.contacts_bouton;
            this.contactButtonLabel = customContactButtonLabel
                ? customContactButtonLabel
                : 'Contacter un expert';

            const technology = this.solarService.technology;
            const isPv = technology === 'pv';

            let pPeak = 0;
            if (isPv) {
                const valorization = this.solarService.valorization;
                const isSurplus = valorization === 'Surplus';

                pPeak = isSurplus
                    ? this.solarPvSurplusService.totalPowerPeak
                    : this.solarPvTotalityService.totalPowerPeak;
            }

            const contact = this.findContact(pPeak);
            if (contact) {
                this.htmlContact = contact.template;
            }

            this.isCofor = this.htmlContact.includes('id="cofor');
            this.isFranceRenov = this.htmlContact.includes('id="france-renov"');
            this.isCitemetrie = this.htmlContact.includes('id="citemetrie"');

            if (this.name === 'cadastre_var') {
                const coforLogoPath = '../../../../assets/img/login/csgp_var/logo_cofor.jpg';
                this.htmlContact = this.htmlContact.replace('{{COFOR_LOGO_PATH}}', coforLogoPath);
                const franceRenovLogoPath =
                    '../../../../assets/img/login/csgp_var/logo_france_renov.png';
                this.htmlContact = this.htmlContact.replace(
                    '{{FRANCE_RENOV_LOGO_PATH}}',
                    franceRenovLogoPath,
                );
                const te83LogoPath = '../../../../assets/img/login/csgp_var/logo_te83.png';
                this.htmlContact = this.htmlContact.replace(
                    '{{TE83_RENOV_LOGO_PATH}}',
                    te83LogoPath,
                );

                const citemetrieLogoPath =
                    '../../../../assets/img/login/csgp_var/logo_bien_chez_soi.png';
                this.htmlContact = this.htmlContact.replace(
                    '{{CITEMETRIE_LOGO_PATH}}',
                    citemetrieLogoPath,
                );
            }
            if (this.name === 'cadastre_hautes_alpes') {
                const coforLogoPath = '../../../../assets/img/login/csgp_hautes_alpes/logo_cofor.jpg';
                this.htmlContact = this.htmlContact.replace('{{COFOR_LOGO_PATH}}', coforLogoPath);
                const franceRenovLogoPath =
                    '../../../../assets/img/login/csgp_var/logo_france_renov.png';
                this.htmlContact = this.htmlContact.replace(
                    '{{FRANCE_RENOV_LOGO_PATH}}',
                    franceRenovLogoPath,
                );
                const te83LogoPath = '../../../../assets/img/login/csgp_hautes_alpes/logo_te05.png';
                this.htmlContact = this.htmlContact.replace(
                    '{{TE83_RENOV_LOGO_PATH}}',
                    te83LogoPath,
                );

                const citemetrieLogoPath =
                    '../../../../assets/img/login/csgp_hautes_alpes/logo_bien_chez_soi.png';
                this.htmlContact = this.htmlContact.replace(
                    '{{CITEMETRIE_LOGO_PATH}}',
                    citemetrieLogoPath,
                );
            }
        }
    }

    findContact(pPeak: number): Contact | undefined {
        const contacts = this.solarService.contactsInfo;
        return contacts.find((c) => {
            if (c.profile !== this.profile) return false;

            const min = c.p_peak_min ?? 0;
            const max = c.p_peak_max ?? Infinity;

            return pPeak >= min && pPeak < max;
        });
    }

    close() {
        this.activeModal.close();
    }
}
